import { SET_SUGGESTION_SEARCH_STATE } from '../constants/actionTypes';

const suggestionSearchActive = (state = false, action) => {
    switch (action.type) {
    case SET_SUGGESTION_SEARCH_STATE:
      return action.is_searching_via_suggestion;
    default:
        return state;
    }
};



export const getsuggestionSearchActive = state => state.suggestionSearchActive;

export default suggestionSearchActive;
